export const submitDetailsStyles = {
  root: {
    bgcolor: 'white',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 148px)',
  },
  content: {
    position: 'absolute',
    left: 0,
    width: '100%',
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    p: 2,
    pb: 'max(8px, env(safe-area-inset-bottom))',
    overflowY: 'auto',
    height: 'calc(100vh - 148px - 74px)',
  },
  stepSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  stepText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    color: '#005c9d',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  titleRow: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'flex-start',
  },
  titleText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.15px',
  },
  requiredMark: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: '#c62828',
  },
  subtitle: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  divider: {
    width: '100%',
    borderTop: '1px solid #e3e6e9',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  sectionHeader: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
  },
  sectionIcon: {
    width: 16,
    height: 16,
  },
  sectionHeaderText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.1px',
  },
  compactField: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  fieldLabel: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  fieldValue: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.1px',
    lineHeight: 1.57,
    overflowWrap: 'anywhere',
  },
  tds10Notice: {
    borderRadius: '8px',
    padding: '12px',
    backgroundColor: '#F4F4F4',
  },
  tds10NoticeText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.43,
    color: '#1f2937',
  },
  tds10Link: {
    color: '#007cbf',
    cursor: 'pointer',
    fontWeight: 600,
    textDecoration: 'underline',
    '&:hover': {
      color: '#006aa8',
    },
  },
  tds20Notice: {
    borderRadius: '8px',
    padding: '12px',
    backgroundColor: '#FFF4E5',
  },
  tds20NoticeText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.43,
    color: '#1f2937',
  },
  tds20Link: {
    color: '#b26a00',
    cursor: 'pointer',
    fontWeight: 600,
    textDecoration: 'underline',
    '&:hover': {
      color: '#8f5400',
    },
  },
  tdsModalPaper: {
    margin: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: '16px 16px 0 0',
    maxWidth: '100%',
    width: '100%',
  },
  tdsModalContainer: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    pb: 3,
    pt: 2,
    px: 2,
    borderRadius: '16px 16px 0 0',
  },
  tdsModalHeader: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    width: '100%',
  },
  tdsModalTitle: {
    flex: 1,
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 20,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.15px',
    lineHeight: 1.6,
  },
  modalCloseButton: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  modalBodyText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.5,
    color: 'rgba(0, 0, 0, 0.74)',
  },
  buttonPanel: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    bgcolor: 'white',
    display: 'flex',
    gap: 1.25,
    p: 2,
  },
  backButton: {
    flex: 1,
    height: 42,
    border: '1px solid rgba(0, 124, 191, 0.5)',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    cursor: 'pointer',
    '&:hover': {
      bgcolor: 'rgba(0, 124, 191, 0.04)',
    },
  },
  backIconWrap: {
    width: 18,
    height: 18,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 15,
    color: '#007cbf',
    letterSpacing: '0.46px',
    lineHeight: '20px',
  },
  submitButton: {
    flex: 1,
    height: 42,
    bgcolor: '#007cbf',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      bgcolor: '#006aa8',
    },
  },
  submitText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 15,
    color: 'white',
    letterSpacing: '0.46px',
  },
  gstCertificateCard: {
    display: 'flex',
    gap: 1.5,
    alignItems: 'center',
    border: '1px solid #e3e6e9',
    borderRadius: '8px',
    padding: '12px 16px',
  },
  gstCertificateIconWrap: {
    width: 32,
    height: 32,
    flexShrink: 0,
  },
  gstCertificateTitle: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.1px',
  },
  gstCertificateViewLink: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 13,
    color: '#007cbf',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};